import { Rating } from "@mui/material";
import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import API from "../../API/newIndex";
import { ChangePathContext } from "../../App";
import Breadcrumbs from "../../controllers/breadCrumbs";
import ImageUploader from "../../controllers/ImageUploader";
import { parentNavigate } from "../../controllers/ParentNavigate";
import Notification from "../Notification";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
  RichTextEditor,
  SelectComponent,
} from "@shopeasy-dashboard-ui/ui-library";

function AddReview() {
  const [image, setimage] = useState();
  const { setSaveChanges } = useContext(ChangePathContext);
  const [selectedProd, setselectedprod] = useState();
  const [Products, setAllProduct] = useState([]);
  const [rate, setRate] = useState();
  const [userName, setUserName] = useState();
  const [description, setDescription] = useState("");
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [autocompleteSearch, setAutocompleteSearch] = useState();
  const searchTimer = useRef(null);

  // fetch All Products
  const GetAllProducts = async ({ search } = {}) => {
    try {
      const params = {};
      if (typeof search === "string" && search.trim().length > 0) {
        params.searchkey = search.trim();
      }
      const products = await API({
        url: `/admin/product/GetProductsName`,
        method: "get",
        params: params,
      });
      if (products.status === 200 || products.status === 304) {
        const result = products?.data;
        setAllProduct(result);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  useEffect(() => {
    GetAllProducts();
  }, []);

  // image upload logic
  const handleSetImage = (value) => {
    setimage(value);
  };
  const [dataErr, setDataErr] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const HandleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!userName || !selectedProd || !rate || !image) {
      setDataErr(true);
      return;
    }
    setBtnLoading(true);
    const payload = {
      description: description,
      rating: rate,
      image: image,
      name: userName,
      product: selectedProd,
    };
    try {
      const apiCall = await API({ url: `/admin/review/addReview`, method: "post", data: payload });
      if (apiCall.status === 200 || apiCall.status === 304) {
        setSaveChanges({
          isUnsaveChanges: false,
          showChangesPopup: false,
          backLink: "/reviews",
          title: "add review",
        });
        parentNavigate("/reviews");
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  useEffect(() => {
    if (
      selectedProd?.length > 0 ||
      userName?.length > 0 ||
      image?.length > 0 ||
      rate?.length > 0 ||
      description?.length > 0
    ) {
      setSaveChanges({
        backLink: "/reviews",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "add review",
      });
    } else {
      setSaveChanges({
        backLink: "/reviews",
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "add review",
      });
    }
  }, [selectedProd, userName, image, rate, description]);

  const checkChanges = () => {
    if (
      selectedProd?.length > 0 ||
      userName?.length > 0 ||
      image?.length > 0 ||
      rate?.length > 0 ||
      description?.length > 0
    ) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: "/reviews",
        title: "add review",
      });
    } else {
      parentNavigate("/reviews");
    }
  };

  const doesMatchExist = (text) => {
    if (!Products?.data?.records?.length) return false;
    const q = text.toLowerCase();
    return Products.data.records.some((p) =>
      `${p.product_name} ${p.sku_id}`.toLowerCase().includes(q),
    );
  };

  // Filter options for product (requires at least 3 characters)
  const filterOptionsForProduct = (option, inputValue) => {
    if (!inputValue || inputValue.trim().length < 3) {
      return false; // No options displayed until at least 3 characters are entered
    }
    const item = option.data;
    const combinedFields = `${item.product_name || item.label || ''} ${item.sku_id || ''}`.toLowerCase();
    return combinedFields.includes(inputValue.toLowerCase());
  };

  // Input change handler with 500ms debounced search API call
  const handleInputChange = (inputValue, { action }) => {
    if (action !== "input-change") return;
    setAutocompleteSearch(inputValue);

    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    if (inputValue.length === 0) {
      GetAllProducts();
      return;
    }
    if (inputValue.length >= 3) {
      const exists = doesMatchExist(inputValue);
      if (!exists) {
        searchTimer.current = setTimeout(() => {
          GetAllProducts({ search: inputValue });
        }, 500);
      }
    }
  };

  // Options for product dropdown
  const productOptions = (Products?.data?.records || []).map((p) => ({
    value: p._id,
    label: p.product_name,
    product_name: p.product_name,
    product_slug_name: p.product_slug_name,
    image: p.image,
    sku_id: p.sku_id,
    _id: p._id,
  }));

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto pb-[130px] pt-5">
        <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
          <div className="flex items-center space-x-2 page-header-pb">
            <button
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              className="back-arrow"
            >
              <ArrowLeft />
            </button>
            <div>
              <Breadcrumbs
                crumbs={[
                  { name: t("lang_dashboard"), path: `/dashboard` },
                  { name: t("lang_Reviews"), path: "/reviews" },
                  { name: t("lang_Add_New_Review"), path: "/reviews/add" },
                ]}
              />
              <h4 className="text-xl md:text-2xl font-semibold text-primary">
                {t("lang_Add_New_Review")}
              </h4>
            </div>
          </div>
        </div>
        <form
          onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
          method="POST"
          className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex flex-col gap-3"
          onSubmit={HandleSubmit}
        >
          <DetailsComponent
            open={true}
            hasHr={false}
            showChevron={false}
            className="!pt-5 sm:!pt-[25px]"
          >
            <div className="mb-4">
              <label htmlFor="userName" className="flex items-center justify-between">
                <p className="text-[13px]">
                  {t("lang_name")}
                  <span className="text-red-500 ms-1">*</span>
                </p>
              </label>
              <InputComponent
                id="userName"
                name="userName"
                value={userName || ""}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="e.g. Smith"
                error={dataErr && !userName ? t("lang_Please_Enter_Name") : ""}
              />
            </div>

            <div className="w-full mb-4">
              <label htmlFor="image">
                <p className="text-[13px] font-medium tracking-tight mb-1">
                  {t("lang_image")}
                  <span className="text-red-500 ms-1">*</span>
                </p>
              </label>
              <ImageUploader
                alreadyImage={image}
                handleSetImage={handleSetImage}
                folder="profile"
                format="image"
              />
              {dataErr && !image && (
                <p className="text-xs text-red-500 font-medium mt-0.5">
                  Please upload an image
                </p>
              )}
            </div>

            <div className="mb-4">
              <label>
                {t("lang_products")}
              </label>
              <SelectComponent
                id="product_select"
                name="product_select"
                required={true}
                placeholder="Select product"
                options={productOptions}
                value={selectedProd}
                onChange={(e) => setselectedprod(e.target.value)}
                onInputChange={handleInputChange}
                filterOption={filterOptionsForProduct}
                noOptionsMessage={(inputObj) =>
                  Products?.data?.records?.length > 0 && !autocompleteSearch
                    ? "Please enter at least 3 characters"
                    : "No option found"
                }
                error={dataErr && !selectedProd ? t("lang_Please_Select_Product") : ""}
                searchable={true}
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-[13px] font-medium">
                {t("lang_Rating")}
                <span className="text-red-500 ms-1">*</span>
              </label>
              <div
                className={`w-full px-3 pt-1 border ${dataErr && !rate ? "border-red-500" : "border-[var(--border-color)]"
                  } rounded-lg bg-[var(--secondary-bg-color)] focus:outline-none`}
              >
                <Rating
                  className="block"
                  name="size-large"
                  size="large"
                  value={Number(rate) || 0}
                  onChange={(e, newValue) => {
                    setRate(newValue);
                  }}
                />
              </div>
              {dataErr && !rate && (
                <p className="text-red-500 text-xs font-medium mt-1">
                  {t("lang_Please_Enter_Rating")}
                </p>
              )}
            </div>

            <div>
              <label className="block mb-1 text-[13px] font-medium capitalize">
                {t("lang_description")}
              </label>
              <RichTextEditor
                htmlData={description}
                setHtmlData={setDescription}
                uplaodImageFile={uploadTextEditorImage}
              />
              <div className="flex w-full justify-end mt-1">
                <p className={`text-xs mt-0 ${(description?.replace(/<[^>]*>/g, ' ')?.split(/\s+/)?.filter(Boolean)?.length || 0) > 280 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                  {`${description?.replace(/<[^>]*>/g, ' ')?.split(/\s+/)?.filter(Boolean)?.length || 0}/280 words`}
                </p>
              </div>
            </div>
          </DetailsComponent>
        </form>

        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-3 left-0">
          <div className="w-[90%] flex items-center justify-between lg:w-[70%] xl:w-[60%] mx-auto">
            <ButtonComponent
              variant="link"
              icon={<ArrowLeft className="w-3" />}
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              className="text-primary"
            >
              {t("lang_Go_To_Reviews")}
            </ButtonComponent>

            <div>
              {!rate || !userName || !selectedProd || !image ? (
                <ButtonComponent
                  variant="primary"
                  disabled={true}
                >
                  {t("lang_Add_New_Review")}
                </ButtonComponent>
              ) : btnLoading ? (
                <ButtonComponent
                  variant="primary"
                  loading={true}
                  className="w-[152px]"
                >
                  {t("lang_loading")}...
                </ButtonComponent>
              ) : (
                <ButtonComponent
                  variant="primary"
                  onClick={(e) => HandleSubmit(e)}
                >
                  {t("lang_Add_New_Review")}
                </ButtonComponent>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddReview;
